export const cleanJSONString = (str) => {
    return str.replace(/[\u0000-\u001F\u007F-\u009F]/g, "");
  };